// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    rootGet (params?: {}): Promise<implicitReturnType>;
    rootGetInfo (params?: {}): Promise<implicitReturnType>;
    publicGetAccount (params?: {}): Promise<implicitReturnType>;
    publicGetAccountsByL1Address (params?: {}): Promise<implicitReturnType>;
    publicGetApikeys (params?: {}): Promise<implicitReturnType>;
    publicGetExchangeStats (params?: {}): Promise<implicitReturnType>;
    publicGetAssetDetails (params?: {}): Promise<implicitReturnType>;
    publicGetOrderBookDetails (params?: {}): Promise<implicitReturnType>;
    publicGetOrderBookOrders (params?: {}): Promise<implicitReturnType>;
    publicGetOrderBooks (params?: {}): Promise<implicitReturnType>;
    publicGetRecentTrades (params?: {}): Promise<implicitReturnType>;
    publicGetBlockTxs (params?: {}): Promise<implicitReturnType>;
    publicGetNextNonce (params?: {}): Promise<implicitReturnType>;
    publicGetTx (params?: {}): Promise<implicitReturnType>;
    publicGetTxFromL1TxHash (params?: {}): Promise<implicitReturnType>;
    publicGetTxs (params?: {}): Promise<implicitReturnType>;
    publicGetAnnouncement (params?: {}): Promise<implicitReturnType>;
    publicGetBlock (params?: {}): Promise<implicitReturnType>;
    publicGetBlocks (params?: {}): Promise<implicitReturnType>;
    publicGetCurrentHeight (params?: {}): Promise<implicitReturnType>;
    publicGetCandles (params?: {}): Promise<implicitReturnType>;
    publicGetFundings (params?: {}): Promise<implicitReturnType>;
    publicGetFastbridgeInfo (params?: {}): Promise<implicitReturnType>;
    publicGetFundingRates (params?: {}): Promise<implicitReturnType>;
    publicGetWithdrawalDelay (params?: {}): Promise<implicitReturnType>;
    publicPostSendTx (params?: {}): Promise<implicitReturnType>;
    publicPostSendTxBatch (params?: {}): Promise<implicitReturnType>;
    privateGetAccountLimits (params?: {}): Promise<implicitReturnType>;
    privateGetAccountMetadata (params?: {}): Promise<implicitReturnType>;
    privateGetPnl (params?: {}): Promise<implicitReturnType>;
    privateGetL1Metadata (params?: {}): Promise<implicitReturnType>;
    privateGetLiquidations (params?: {}): Promise<implicitReturnType>;
    privateGetPositionFunding (params?: {}): Promise<implicitReturnType>;
    privateGetPublicPoolsMetadata (params?: {}): Promise<implicitReturnType>;
    privateGetAccountActiveOrders (params?: {}): Promise<implicitReturnType>;
    privateGetAccountInactiveOrders (params?: {}): Promise<implicitReturnType>;
    privateGetExport (params?: {}): Promise<implicitReturnType>;
    privateGetTrades (params?: {}): Promise<implicitReturnType>;
    privateGetAccountTxs (params?: {}): Promise<implicitReturnType>;
    privateGetDepositHistory (params?: {}): Promise<implicitReturnType>;
    privateGetTransferHistory (params?: {}): Promise<implicitReturnType>;
    privateGetWithdrawHistory (params?: {}): Promise<implicitReturnType>;
    privateGetReferralPoints (params?: {}): Promise<implicitReturnType>;
    privateGetTransferFeeInfo (params?: {}): Promise<implicitReturnType>;
    privatePostChangeAccountTier (params?: {}): Promise<implicitReturnType>;
    privatePostNotificationAck (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
